<div #sectionInstr (click)="adminSelection()">
  <span *ngIf="!placeholderActive" class="instruction-content" [innerHTML]="sectionContent | trustHtml"></span>
  <span *ngIf="placeholderActive && admin" class="admin-placeholder instruction-content" ><em>Click here to add instruction text</em></span>  
</div>
<p-overlayPanel [dismissable]="false" [showCloseIcon]="true" [focusOnShow]="true" #opInstructions [style]="{width: '92%', marginTop: '15px'}" (onHide)="getContentFromDb()">
  <div class="propertyInput p-formgroup-inline p-mb-4">
    <div class="p-field">
      <label for="FieldLabelContentInstr" i18n>Instruction Content</label><br />
      <p-editor #FieldLabelContentInstr name="FieldLabelContentInstr" id="FieldLabelContentInstr" [(placeholder)]="placeholderContent" [(ngModel)]="editorContent"
      ngDefaultControl >
        <p-header>
          <div #toolbar class="toolbar ql-toolbar ql-snow">
            <span class="ql-formats">
              <select class="ql-header">
                <option value="1">Heading</option>
                <option value="2">Subheading</option>
                <option selected="">Normal</option>
              </select>
            </span>
            <span class="ql-formats">
              <select class="ql-font" tabindex="-1">
                <option selected>Sans Serif</option>
                <option value="serif">Serif</option>
                <option value="monospace">Monospace</option>
              </select>
            </span>
            <span class="ql-formats">
              <button class="ql-bold" aria-label="Bold"></button>
              <button class="ql-italic" aria-label="Italic"></button>
              <button class="ql-underline" aria-label="Underline"></button>
            </span>
            <span class="ql-formats">
              <select class="ql-color"></select>
              <select class="ql-background"></select>
            </span>
            <span class="ql-formats">
              <button class="ql-list" value="ordered"></button>
              <button class="ql-list" value="bullet"></button>
              <select title="Text Alignment" class="ql-align">
                <option selected>Gauche</option>
                <option value="center" label="Center"></option>
                <option value="right" label="Right"></option>
                <option value="justify" label="Justify"></option>
              </select>
            </span>
            <span class="ql-formats">
              <button aria-label="Link" class="ql-link"></button>
              <button aria-label="image" class="ql-image"></button>
            </span>
            <span class="ql-formats">
              <button class="ql-clean" aria-label="Remove Styles"></button>
            </span>
          </div>
        </p-header>
        <div id="editor"></div>
      </p-editor>

    </div>
  </div>
  <accela-button-primary type="button" (click)="submitAdminContentUpdate()" i18n-label label="Submit" pRipple></accela-button-primary>  
</p-overlayPanel>
